export default __webpack_public_path__ + "static/media/logo-animation-dark.48e4320e.gif";